import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './hooks/useAuth';
import { RoleProtectedRoute } from './components/RoleProtectedRoute';
import { LocationSaver } from './components/LocationSaver';
import { AuthPage } from './pages/AuthPage';
import { routeConfig } from './routes';

const LAST_VISITED_PATH_KEY = 'last_visited_path';

export const AppRouter: React.FC = () => {
  const { isAuthenticated, initialLoading } = useAuth(); // Використовуємо initialLoading

  // Показуємо глобальний спіннер тільки під час початкової перевірки
  if (initialLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const lastVisitedPath = sessionStorage.getItem(LAST_VISITED_PATH_KEY);
  const defaultRedirectPath = lastVisitedPath || '/dashboard';

  return (
    <>
      <LocationSaver />
      <Routes>
        {/* Public auth route */}
        <Route
          path="/auth"
          element={isAuthenticated ? <Navigate to={defaultRedirectPath} replace /> : <AuthPage />}
        />

        {/* Dynamically generated routes */}
        {routeConfig.map(({ path, component: Component, allowedRoles, isPublic }) => (
          <Route
            key={path}
            path={path}
            element={
              isPublic ? (
                <Component />
              ) : isAuthenticated ? (
                <RoleProtectedRoute allowedRoles={allowedRoles}>
                  <Component />
                </RoleProtectedRoute>
              ) : (
                <Navigate to="/auth" replace />
              )
            }
          />
        ))}

        {/* Default redirect */}
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? defaultRedirectPath : '/auth'} replace />}
        />

        {/* 404 Not Found */}
        <Route path="*" element={<div>Сторінка не знайдена</div>} />
      </Routes>
    </>
  );
};
